"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toast = _interopRequireDefault(require("./toast"));
Entry.ZoomController = /*#__PURE__*/function () {
  function ZoomController(board) {
    (0, _classCallCheck2["default"])(this, ZoomController);
    (0, _defineProperty2["default"])(this, "ZOOM_LEVEL", 2);
    this.boardMap = new Map();
    if (board) {
      this.setBoard(board);
    }
    if (Entry.windowResized) {
      Entry.windowResized.attach(this, this.setPosition);
    }
  }
  return (0, _createClass2["default"])(ZoomController, [{
    key: "CONTROLLER_WIDTH",
    get: function get() {
      return 128;
    }
  }, {
    key: "CONTROLLER_HEIGHT",
    get: function get() {
      return 38;
    }
  }, {
    key: "ZOOM_RANGE",
    get: function get() {
      return [0.6, 0.8, 1, 1.3, 1.6, 2];
    }
  }, {
    key: "ZOOM_MODE",
    get: function get() {
      return {
        RESET: 0,
        OUT: 1,
        IN: 2
      };
    }
  }, {
    key: "view",
    get: function get() {
      return this.svgGroup;
    }
  }, {
    key: "generateView",
    value: function generateView() {
      var zoomGroup = {
        svgZoom: this.nowBoard.svg.elem('g')
      };
      this.renderStart(zoomGroup);
      this.addControl(zoomGroup);
      zoomGroup.toast = new _toast["default"](this.nowBoard);
      return zoomGroup;
    }
  }, {
    key: "renderStart",
    value: function renderStart(zoomGroup) {
      var _ref = EntryStatic.images || {},
        _ref$btn_zoom_bg = _ref.btn_zoom_bg,
        btn_zoom_bg = _ref$btn_zoom_bg === void 0 ? "".concat(Entry.mediaFilePath, "btn_zoom_bg.svg") : _ref$btn_zoom_bg,
        _ref$btn_zoom_out = _ref.btn_zoom_out,
        btn_zoom_out = _ref$btn_zoom_out === void 0 ? "".concat(Entry.mediaFilePath, "btn_zoom_out.svg") : _ref$btn_zoom_out,
        _ref$btn_zoom_reset = _ref.btn_zoom_reset,
        btn_zoom_reset = _ref$btn_zoom_reset === void 0 ? "".concat(Entry.mediaFilePath, "btn_zoom_reset.svg") : _ref$btn_zoom_reset,
        _ref$btn_zoom_in = _ref.btn_zoom_in,
        btn_zoom_in = _ref$btn_zoom_in === void 0 ? "".concat(Entry.mediaFilePath, "btn_zoom_in.svg") : _ref$btn_zoom_in;
      var isSafari = Entry.getBrowserType().indexOf('Safari') >= 0;
      var shadowFilter = isSafari ? 'none' : 'url(#entryButtonShadowFilter)';
      zoomGroup.svgZoom.elem('image', {
        href: btn_zoom_bg,
        width: this.CONTROLLER_WIDTH,
        height: this.CONTROLLER_HEIGHT
      });
      zoomGroup.zoomOut = zoomGroup.svgZoom.elem('image', {
        href: btn_zoom_out,
        x: 4,
        y: 3,
        width: 32,
        height: 32,
        filter: shadowFilter,
        style: 'cursor: default; cursor: -moz-zoom-out; cursor: -webkit-zoom-out; cursor: -ms-zoom-out; cursor: -o-zoom-out;'
      });
      zoomGroup.zoomReset = zoomGroup.svgZoom.elem('image', {
        id: 'zoom_reset',
        href: btn_zoom_reset,
        x: 44,
        y: 3,
        width: 40,
        height: 32,
        filter: shadowFilter,
        style: 'cursor: pointer;'
      });
      zoomGroup.zoomIn = zoomGroup.svgZoom.elem('image', {
        href: btn_zoom_in,
        x: 92,
        y: 3,
        width: 32,
        height: 32,
        filter: shadowFilter,
        style: 'cursor: default; cursor: -moz-zoom-in; cursor: -webkit-zoom-in; cursor: -ms-zoom-in; cursor: -o-zoom-in;'
      });
    }
  }, {
    key: "addControl",
    value: function addControl(zoomGroup) {
      var _this = this;
      if (this.nowBoard) {
        $(zoomGroup.svgZoom).bind('mousedown touchstart', function (e) {
          e.stopImmediatePropagation();
        });
        $(zoomGroup.zoomOut).bind('mousedown touchstart', function (e) {
          _this.zoomChange(_this.ZOOM_MODE.OUT);
        });
        $(zoomGroup.zoomReset).bind('mousedown touchstart', function (e) {
          _this.zoomChange(_this.ZOOM_MODE.RESET);
        });
        $(zoomGroup.zoomIn).bind('mousedown touchstart', function (e) {
          _this.zoomChange(_this.ZOOM_MODE.IN);
        });
      }
    }
  }, {
    key: "zoomChange",
    value: function zoomChange(mode) {
      switch (mode) {
        case this.ZOOM_MODE.OUT:
          if (this.ZOOM_LEVEL > 0) {
            this.ZOOM_LEVEL -= 1;
            this.setScale(this.ZOOM_RANGE[this.ZOOM_LEVEL]);
          }
          break;
        case this.ZOOM_MODE.IN:
          if (this.ZOOM_LEVEL < this.ZOOM_RANGE.length - 1) {
            this.ZOOM_LEVEL += 1;
            this.setScale(this.ZOOM_RANGE[this.ZOOM_LEVEL]);
          }
          break;
        case this.ZOOM_MODE.RESET:
        default:
          var resetIndex = this.ZOOM_RANGE.indexOf(1);
          if (this.ZOOM_LEVEL !== resetIndex) {
            this.ZOOM_LEVEL = 2;
            this.setScale(this.ZOOM_RANGE[this.ZOOM_LEVEL]);
          }
          break;
      }
    }
  }, {
    key: "setScale",
    value: function setScale() {
      var scale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var zoomGroup = this.boardMap.get(this.nowBoard);
      var workspace = this.nowBoard.workspace;
      workspace.setScale(scale);
      zoomGroup.toast.show("".concat(scale * 100, "%"));
      var scroller = this.nowBoard.scroller;
      scroller.resizeScrollBar && scroller.resizeScrollBar.call(scroller);
    }
  }, {
    key: "setPosition",
    value: function setPosition() {
      if (!this.nowBoard) {
        return;
      }
      var svgDom = this.nowBoard.svgDom;
      this.x = svgDom.width() - (this.CONTROLLER_WIDTH + 22.5);
      this.y = 8;
      this.align();
    }
  }, {
    key: "getPosition",
    value: function getPosition() {
      return {
        x: this.x,
        y: this.y
      };
    }
  }, {
    key: "align",
    value: function align() {
      var position = this.getPosition();
      this.boardMap.forEach(function (zoomGroup) {
        zoomGroup.svgZoom.attr({
          transform: "translate(".concat(position.x, ", ").concat(position.y, ")")
        });
      });
    }
  }, {
    key: "setBoard",
    value: function setBoard(board) {
      this.nowBoard = board;
      var zoomGroup = this.boardMap.get(board);
      if (!zoomGroup) {
        this.boardMap.set(board, this.generateView());
      }
      this.setPosition();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.boardMap.forEach(function (zoomGroup) {
        if (zoomGroup.toast) {
          zoomGroup.toast.destroy();
        }
      });
      delete this.nowBoard;
      delete this.boardMap;
    }
  }]);
}();